import { createStyles, makeStyles } from '@mui/styles';

const useStyles = makeStyles(() =>
  createStyles({
    loadingContainer: {
      marginTop: '30vh',
    },
  })
);

export default useStyles;
